import {
    APPLICATIONS_POST_FAILURE,
    APPLICATIONS_POST_REQUEST,
    APPLICATIONS_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const applicationPostReducer = (state = initialState, action) => {
    const {type, location} = action;
    switch (type) {
        case APPLICATIONS_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            location,
        }}

        case APPLICATIONS_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case APPLICATIONS_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
